var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.4561 5.54381c-3.5656-3.56566-9.34668-3.56566-12.91234.00001h-.00001c-3.56566 3.5656-3.56566 9.34668.00001 12.91238l-.30744.3074.30744-.3074c3.5656 3.5656 9.34674 3.5657 12.91234 0 3.5657-3.5656 3.5657-9.34672 0-12.91239zm-13.52722-.61487c3.90525-3.90525 10.23692-3.90525 14.14212 0 3.9053 3.90525 3.9053 10.23696 0 14.14216s-10.23693 3.9052-14.14212 0c-3.90525-3.9053-3.90526-10.23697 0-14.14216zm7.07102 3.1619c-1.2007 0-2.17388.97299-2.17388 2.17356 0 .2401-.19466.4347-.43479.4347-.24012 0-.43478-.1946-.43478-.4347 0-1.68099 1.36275-3.04313 3.04345-3.04313 1.6809 0 3.0435 1.36262 3.0435 3.04353 0 1.2099-.7167 2.305-1.8256 2.7892h-.0002c-.4755.2074-.7829.6768-.7829 1.1956v.3582c0 .2402-.1946.4348-.4348.4348-.2401 0-.4348-.1946-.4348-.4348v-.3582c.0001-.8645.5123-1.6469 1.3047-1.9925.7921-.3459 1.3041-1.1281 1.3041-1.9923 0-1.20066-.9733-2.17396-2.174-2.17396zm-.6521 8.47356c0-.3602.2919-.6522.6521-.6522s.6522.292.6522.6522-.292.6522-.6522.6522-.6521-.292-.6521-.6522zm.6521.2174c.1201 0 .2174-.0974.2174-.2174 0-.1201-.0973-.2174-.2174-.2174-.12 0-.2174.0973-.2174.2174 0 .12.0974.2174.2174.2174z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f39099c2a25f0b430d9642edad1686ee.svg";
export { ForwardRef as ReactComponent };